import React from "react";

export default function Logo() {
  return (
    <div className="logo">
      <a href="/" target="_blank">
        <img src="/img/3d_smile_logo_rgb.svg" alt="" style={{ width: "200px" }} />
      </a>
    </div>
  );
}
